












import { Component, mixins, Prop, namespace } from 'nuxt-property-decorator'
import { mdiEyeOutline } from '@mdi/js'
import MixinGeneral from '~/assets/mixins/general'
import ComponentIcon from '~/components/icon/icon.vue'

const siteStore = namespace('site')
const quickViewStore = namespace('quickView')

// Кнопка быстрого просмотра в карточке. Сама решает, быть ли ей: функцию
// включает бэк, а показываем только на десктопе — кнопка проявляется по
// наведению, на тач-экранах наведения нет. Позицию на фото и появление по
// hover задаёт карточка (миксин product-card-quick-view).
@Component({
  components: {
    ComponentIcon,
  },
})
export default class ComponentProductQuickViewButton extends mixins(
  MixinGeneral
) {
  @Prop({ type: String, required: true }) readonly url!: string

  @siteStore.Getter('getOptionsQuickView') private isEnabled!: boolean
  @quickViewStore.Mutation('open') private open!: (url: string) => void

  private mdiEyeOutline = mdiEyeOutline

  private get isVisible() {
    return this.isEnabled && !this.isMobile
  }
}
